import cn from 'classnames'
import { Formik, Form } from 'formik'

import { InputField } from '@components/forms/InputField'
import { Button } from '@components/Buttons'
import { MultiSelectField } from '@components/forms/MultiSelectField'
import { initialValues as defaultValues } from '@constants/form/myWritingSearchForm/initialValues'
import { AdvanceIcon } from '@components/icons/AdvanceIcon'
import { SearchIcon } from '@components/icons/SearchIcon'
import { SearchFormPropsType } from './interface'

export function SearchForm({
  initialValues,
  advanceSearch,
  bookType,
  categories,
  penNameOptions,
  handleSubmit,
  handleAdvanceSearchChange,
}: SearchFormPropsType) {
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ isSubmitting, resetForm }) => (
          <Form>
            <div className='grid gap-y-[20px] '>
              <div
                className={cn(
                  'flex desktop-tablet:space-x-[20px] mobile:gap-y-[20px] mobile:grid'
                )}
              >
                <InputField
                  name='param'
                  placeholder='ค้นหางานเขียน, นามปากกา'
                  inputClassName='font-light bg-gray-4 text-secondary-1 rounded-[20px] border-none '
                  className='flex-1'
                  leftIcon={
                    <SearchIcon
                      className=' text-primary'
                      width='20'
                      height='20'
                    />
                  }
                />
                <Button
                  type='button'
                  onClick={handleAdvanceSearchChange}
                  className={cn('border', {
                    'bg-secondary dark:bg-purple text-white dark:text-white-2 dark:border-purple':
                      !advanceSearch,
                    'bg-white dark:bg-dark-7 text-sencondary dark:text-dark-10 dark:border-dark-10':
                      advanceSearch,
                  })}
                  icon={
                    <AdvanceIcon
                      className={cn({
                        'text-white dark:text-white-2': !advanceSearch,
                        'text-secondary dark:text-dark-10': advanceSearch,
                      })}
                    />
                  }
                >
                  <span className='text-[14px] font-medium'>
                    การค้นหาขั้นสูง
                  </span>
                </Button>
              </div>
              {advanceSearch && (
                <div className='flex mobile:grid mobile:gap-y-[20px]'>
                  <div className='grid grid-cols-3 tablet:grid-cols-2 mobile:grid-cols-1  gap-[20px] flex-1'>
                    <MultiSelectField
                      name='bookType'
                      label='ลักษณะงานเขียน'
                      placeholder='ลักษณะงานเขียน'
                      options={bookType}
                    />
                    <MultiSelectField
                      name='category'
                      label='หมวดหมู่'
                      placeholder='หมวดหมู่'
                      options={categories}
                    />
                    <MultiSelectField
                      name='penName'
                      label='นามปากกา'
                      placeholder='นามปากกา'
                      options={penNameOptions}
                    />
                    <div className='flex items-center justify-end ml-[25px] tablet:items-end desktop:hidden mobile:hidden'>
                      <Button
                        type='reset'
                        className='text-secondary dark:text-white-2 underline'
                      >
                        <span className='text-[14px] font-medium'>ล้างค่า</span>
                      </Button>
                      <Button
                        type='submit'
                        className='bg-primary dark:bg-purple text-white dark:text-white-2'
                        disabled={isSubmitting}
                      >
                        <span className='text-[14px] font-medium'>ค้นหา</span>
                      </Button>
                    </div>
                  </div>
                  <div className='flex items-center justify-end ml-[30px] tablet:hidden'>
                    <Button
                      type='button'
                      className='text-secondary dark:text-dark-10 underline'
                      onClick={() => {
                        resetForm({ values: defaultValues })
                        handleSubmit(defaultValues)
                      }}
                    >
                      <span className='text-[14px] font-medium'>ล้างค่า</span>
                    </Button>
                    <Button
                      type='submit'
                      className='bg-primary dark:bg-purple text-white dark:text-white-2'
                      disabled={isSubmitting}
                    >
                      <span className='text-[14px] font-medium'>ค้นหา</span>
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}
